import React, { FC, Suspense } from 'react';
import ErrorBoundary from '../../atoms/errorBoundary';
import { SearchMobileModalProps } from './searchMobile.types';

const SearchMobileModal = React.lazy(() => import('./searchMobileModal'));

const SearchMobileModalLazy: FC<SearchMobileModalProps> = props => {
  return (
    <ErrorBoundary>
      <Suspense fallback={''}>
        <SearchMobileModal {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default SearchMobileModalLazy;
